export const ICON_SIZE = {
  LARGE: 'large',
  MEDIUM: 'medium',
  SMALL: 'small',
  XSMALL: 'xsmall',
};

export const sizes = {
  [ICON_SIZE.LARGE]: 30,
  [ICON_SIZE.MEDIUM]: 16,
  [ICON_SIZE.SMALL]: 12,
  [ICON_SIZE.XSMALL]: 8,
};
